/**
 * title -> string = titulo
 * backgroundColor -> string = backgroundColor
 * backgroundColorContent -> string = backgroundColor do conteudo
 * contentColor -> string = Cor do conteúdo interno do accordion
 * paddingTitle -> string = padding para o title,
 * paddingContent -> string = padding para o content,
 * ignoreIconSpace -> bool = ignorar o space default do icone
 * className -> string = custom class
 */
import React, { useState } from 'react';
import './Accordion.css';
import getImage from '../../useFull/getImage';

const Accordion = (props) => {
    const [isOpen, setIsOpen] = useState(false);
    const {
        title,
        backgroundColor,
        backgroundColorContent,
        contentColor,
        paddingTitle,
        paddingContent,
        ignoreIconSpace,
        className,
        children,
        isOpenBoxShadow
    } = props

    const toggleAccordion = () => {
        setIsOpen(!isOpen);
    };

    return (
        <div className={`accordion ${className} ${isOpen & isOpenBoxShadow ? 'w-box-shadow-transition' : 'close'}`} style={{
            ...(backgroundColor ? { backgroundColor } : {})
        }}>
            <div className="accordion-header" onClick={toggleAccordion} style={{
                ...(paddingTitle ? { padding: paddingTitle } : {}),
                ...(ignoreIconSpace ? { justifyContent: 'flex-start' } : {}),
                
                
            }}>
                <span>{title}</span>
                <div className={`bg-icon  ${isOpen && 'rotate'}`} style={{ backgroundImage: `url(${getImage('icons', 'arrow-orange.png')})`}}></div>
            </div>
            <div className={`accordion-content ${isOpen ? 'open' : ''}`}>
                <div className={`accordion-content-inner`} style={{
                    ...(contentColor ? { color: contentColor} : {}),
                    ...(backgroundColorContent ? { backgroundColor: backgroundColorContent } : {}),
                    ...(paddingContent ? { padding: paddingContent } : {}),
                }}>
                    {children}
                </div>
            </div>
        </div>
    );
};

export default Accordion;
